import { useState, useEffect } from "react";
import { useNavigate } from "react-router"
import Logo from "../../logo.svg";
import "./css/navbar.css";
import "./css/navbar-phone.css";

export default function Navbar(params) {

  let navigate = useNavigate();
  const [menu, setMenu] = useState([])

  useEffect(() => {
    if (params.menu) {
      if (Array.isArray(params.menu)) {
        setMenu(params.menu)
      }
    }
  }, [params])


  const LogOut = (e) => {
    e.preventDefault();
    localStorage.removeItem("ContaKMPCot");
    navigate("/");
  }

  return (
    <div className="Cli-Nav">
    <nav>
      <ul>
        <li>
          <span><img src={Logo} alt="Logo KMP" /></span>
          <span className="li-left"></span>
          <span className="li-rigth-logout" onClick={LogOut}>Cerrar Sesion</span>
          {
            menu.map((el, ind) => (
              <span key={ind} className="li-rigth-button" onClick={
                (e) => {
                  navigate(el.link);
                }
              }>{el.txt}</span>
            ))
          }
        </li>
        <li>{params.search}</li>
      </ul>
    </nav>
    <div>
      {params.children}
    </div>
    </div>
  )
}
